import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  dispatcherDispexValue,
  roundIconBgTypes,
} from '../../../../constants/common';
import { ReactComponent as CallIcon } from '../../../../../../resource/CallIcon.svg';
import RoundIconBackground from '../../../RoundIconBackground/RoundIconBackground';
import {
  companyVisibleValueSelector,
  phoneFieldValueSelector,
  serviceCompanyValueSelector,
} from '../../../../store/selectors';
import useSipStates from '../../../../../../hooks/useSipStates';
import { Icon, Popconfirm } from 'antd';
import useCallHandler from '../../../../hooks/useCallHandler';
import Title from '../Title/Title';
import {
  setCompanyVisible,
  setServiceCompanyValue,
} from '../../../../store/actions';
import usePhoneFieldCallHandler from '../../../../hooks/usePhoneFieldCallHandler';

const Call = () => {
  const phoneFieldValue = useSelector(phoneFieldValueSelector);
  const serviceCompany = useSelector(serviceCompanyValueSelector);
  const companyVisible = useSelector(companyVisibleValueSelector);
  const dispatcherUser = useSelector(
    (state) => state.authentication.userInfo.Dispatcher
  );

  const dispatch = useDispatch();

  const setCompanyState = (val) => dispatch(setCompanyVisible(val));

  const isDispatcherDispex = dispatcherUser === dispatcherDispexValue;

  const missingRequiredServiceCompany = !serviceCompany && isDispatcherDispex;

  const { isConnected, isIdle } = useSipStates();

  const { handleCall } = usePhoneFieldCallHandler();

  const { handleClickCall, isLoading } = useCallHandler();

  const handleConfirm = () => {
    dispatch(setServiceCompanyValue(companyVisible));
    setCompanyState(null);
    handleCall();
  };

  const handleCancel = () => {
    setCompanyState(null);
    handleCall();
  };

  const handleClick = async () => {
    if (!isDispatcherDispex) {
      handleCall();
      return;
    }

    await handleClickCall();
  };

  const disabled =
    !isConnected ||
    !isIdle ||
    !phoneFieldValue ||
    missingRequiredServiceCompany;

  useEffect(() => () => setCompanyState(null), []);

  return (
    <Popconfirm
      title={<Title company={companyVisible} />}
      placement="topRight"
      visible={Boolean(companyVisible)}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
      okText="Да"
      cancelText="Нет"
      getPopupContainer={() => document.body}
      overlayStyle={{ zIndex: 20000 }}
    >
      <RoundIconBackground
        onClick={handleClick}
        containerType={
          disabled ? roundIconBgTypes.disconnected : roundIconBgTypes.call
        }
        renderIcon={({ className }) =>
          isLoading ? (
            <Icon type="loading" />
          ) : (
            <CallIcon className={className} />
          )
        }
        disabled={disabled}
      />
    </Popconfirm>
  );
};

export default Call;
